module.exports = __webpack_public_path__ + "media/error.e42148b3.wav";